import React from "react"

import { colors } from "@bullseye/tailwind-config"

const Instagram = () => (
  <svg
    width="32"
    height="32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-label="Instagram"
  >
    <path
      d="M22.666 2.668H9.333a6.667 6.667 0 00-6.667 6.667v13.333a6.667 6.667 0 006.667 6.667h13.333a6.667 6.667 0 006.667-6.667V9.335a6.667 6.667 0 00-6.667-6.667z"
      stroke={`${colors.gray[950]}`}
      strokeWidth="1"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M21.334 15.16a5.333 5.333 0 11-10.552 1.565 5.333 5.333 0 0110.552-1.565z"
      fill="#fff"
      stroke={`${colors.gray[950]}`}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M23.334 8.668h.013"
      stroke={`${colors.gray[950]}`}
      strokeWidth="1"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export default Instagram
